<template>
  <v-data-table
    item-key="id"
    disableSort
    :items-per-page="-1"
    :headers="headers"
    :items="items"
    hide-default-footer
    class="mt-3 elevation-1"
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item | ordinalNumber(items) }}
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ $_get(item, 'student.dob') | ddmmyyyy }}
    </template>
    <template v-slot:[`item.gender`]="{ item }">{{ $_get(item, 'student.gender')| gender }}</template>
    <template v-slot:[`item.class`]="{ item }">
      {{ $_get(item, 'class.title', '--') }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-menu offset-y bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon color="#0D47A1">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title
              style="cursor: pointer;"
              @click="onRemove(item.student)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
const headers = [
  { text: 'STT', value: 'index' },
  { text: 'Học sinh', value: 'name' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Giới tính', value: 'gender', align: 'left', sortable: false },
  { text: 'Lớp', value: 'class' },
  { text: 'Thao tác', value: 'actions', align: 'end' },
]
export default {
  components: { CardStudentName },
  data: () => ({ headers }),
  computed: {
    ...mapGetters({ items: 'boardingClassStudent/items' }),
  },
  methods: {
    ...mapActions({ fetchItems: 'boardingClassStudent/fetchItems', removeItem: 'boardingClassStudent/removeSingle' }),
    onRemove(student = '') {
      this.$dialog.confirm({
        title: 'Xóa nhận xóa học sinh?',
        text: 'Học sinh sẽ được gỡ bỏ khỏi lớp bán trú này. Bạn có chắc chắn muốn xoá học sinh khỏi lớp bán trú này không?',
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        type: 'delete',
        done: async () => {
          this.$loading.active = true
          try {
            await this.removeItem({ id: this.$route.params.id, student })
            await this.onRefresh()
            this.$alert.success('Xoá học sinh thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
    onRefresh() {
      return this.fetchItems({ _sort: 'nameToNumber:ASC', boardingClasses: this.$route.params.id })
    },
  },
  async mounted() {
    await this.onRefresh()
  },
}
</script>
